import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import PropTypes from 'prop-types';

const BulkController = ({ deleteCompleted, deleteSelected, reset }) => {
    return (
        <ButtonGroup>
            <Button color="danger" onClick={deleteSelected}>Clear selected</Button>
            <Button color="danger" onClick={deleteCompleted}>Clear completed</Button>
            <Button color="danger" onClick={reset}>Reset</Button>
        </ButtonGroup>
    );
};

BulkController.propTypes = {
    deleteCompleted: PropTypes.func.isRequired,
    deleteSelected: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
};

export default BulkController;